import React, {Component} from 'react'
import TaxEditForm from "./taxEditForm.component.jsx"
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import {FormattedMessage} from 'react-intl'
import SideBar from '../../common/layout/sidebar.component.jsx'

class TaxEdit extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            tax: {},
            taxName: ''
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        const taxId = this.props.match.params.taxId
        AppContext.getApiClient().get('/taxes/' + taxId).then((tax) => {
            AppContext.getApiClient().get('/taxes/default').then((resDefault) => {

                const taxEditForm = <TaxEditForm tax={tax} defaultTax={resDefault}/>
                this.setState({
                    taxName: tax.attributes.name,
                    taxEditForm: taxEditForm,
                    defaultTax: resDefault
                })

            });
        });
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 ui-title-bar">
                        <div className="row">
                            <div className="col-12">
                                <h2>
                                    <FormattedMessage
                                        id="tax.form.edit.title"
                                        defaultMessage="Edit: {taxName}"
                                        values={{taxName: this.state.taxName}}
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.taxEditForm}

            </div>
        );
    }
}

export default TaxEdit


// WEBPACK FOOTER //
// ./src/settings/taxes/taxEdit.component.jsx